document.addEventListener("DOMContentLoaded", () => {

    /* ==============================
    Animación del carrito
    ============================== */
    setInterval(() => {
        const carrito = document.querySelector('.carrito');
        if (!carrito) return;

        carrito.classList.remove('animar');
        void carrito.offsetWidth;
        carrito.classList.add('animar');
    }, 10000);


    /* ==============================
    Efecto máquina de escribir
    ============================== */
    const palabras = [
        "RECÁMARAS",
        "ANTECOMEDORES",
        "SALAS",
        "DECORACIONES",
        "OTROS MUEBLES",
        "SEPTIEMBRE"
    ];

    const input = document.getElementById("buscador");

    if (input) {

        let palabraIndex = 0;
        let letraIndex = 0;
        let escribiendo = true;

        const velocidadEscritura = 100;
        const velocidadBorrado = 60;
        const pausaFinal = 3000;

        function maquinaEscribir() {

            const palabraActual = palabras[palabraIndex];

            if (escribiendo) {

                if (letraIndex < palabraActual.length) {

                    input.placeholder =
                        "BUSCAR: " +
                        palabraActual.substring(0, letraIndex + 1);

                    letraIndex++;

                    setTimeout(maquinaEscribir, velocidadEscritura);

                } else {

                    setTimeout(() => {
                        escribiendo = false;
                        maquinaEscribir();
                    }, pausaFinal);
                }

            } else {

                if (letraIndex > 0) {

                    input.placeholder =
                        "BUSCAR: " +
                        palabraActual.substring(0, letraIndex - 1);

                    letraIndex--;

                    setTimeout(maquinaEscribir, velocidadBorrado);

                } else {

                    escribiendo = true;
                    palabraIndex = (palabraIndex + 1) % palabras.length;

                    setTimeout(maquinaEscribir, velocidadEscritura);
                }
            }
        }

        maquinaEscribir();


        /* ==============================
        AUTOCOMPLETADO GHOST TEXT
        ============================== */
        const catalogo = [
            "silla", "sillón", "sofá", "sala", "salón",
            "recámara", "ropero", "repisa",
            "mesa", "mesa de centro", "mesa de comedor", "mesa de noche",
            "cama", "cajonera", "colchón",
            "librero", "lámpara", "decoración",
            "tocador", "vitrina", "aparador",
            "comedor", "antecomedor", "banca",
            "escritorio", "silla de escritorio",
            "taburete", "puff", "otomana",
            "estante", "estantería", "anaquel",
            "cabecera", "base de cama", "cuna",
            "armario", "clóset"
        ];

        const ghostTyped = document.getElementById("ghostTyped");
        const ghostSuggestion = document.getElementById("ghostSuggestion");

        function normalizar(str) {
            return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        }

        let sugerenciaActual = "";

        function actualizarGhost() {

            const val = input.value;
            const ghostHint = document.getElementById("ghostHint");

            if (!val) {
                if (ghostTyped) ghostTyped.textContent = "";
                if (ghostSuggestion) ghostSuggestion.textContent = "";
                if (ghostHint) ghostHint.classList.remove("visible");
                sugerenciaActual = "";
                return;
            }

            const norm = normalizar(val);

            const match = catalogo.find(p =>
                normalizar(p).startsWith(norm) && normalizar(p) !== norm
            );

            sugerenciaActual = match ? match.slice(val.length) : "";

            if (ghostTyped) ghostTyped.textContent = val;
            if (ghostSuggestion) ghostSuggestion.textContent = sugerenciaActual;

            if (ghostHint) {
                if (sugerenciaActual) {
                    ghostHint.classList.add("visible");
                } else {
                    ghostHint.classList.remove("visible");
                }
            }
        }

        input.addEventListener("input", actualizarGhost);

        input.addEventListener("keydown", (e) => {
            if ((e.key === "Tab" || e.key === "ArrowRight") && sugerenciaActual) {
                e.preventDefault();
                input.value += sugerenciaActual;
                sugerenciaActual = "";
                if (ghostSuggestion) ghostSuggestion.textContent = "";
                if (ghostTyped) ghostTyped.textContent = input.value;
            }
        });
    }


    /* ==============================
    COUNTDOWN INTELIGENTE
    ============================== */
    function initCountdown() {

        const wrapper = document.querySelector(".countdown-wrapper");
        if (!wrapper) return;

        const endDate = new Date(wrapper.dataset.end).getTime();

        const daysEl = wrapper.querySelector(".cd-days");
        const hoursEl = wrapper.querySelector(".cd-hours");
        const minutesEl = wrapper.querySelector(".cd-minutes");
        const secondsEl = wrapper.querySelector(".cd-seconds");

        function update() {

            const now = new Date().getTime();
            let diff = endDate - now;

            if (diff <= 0) diff = 0;

            const totalSeconds = Math.floor(diff / 1000);

            const days = Math.floor(totalSeconds / (3600 * 24));
            const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            if (days >= 2) {
                wrapper.classList.add("format-days");

                const daysBox = wrapper.querySelector(".days-box");
                const secondsBox = wrapper.querySelector(".seconds-box");

                if (daysBox) daysBox.style.display = "flex";
                if (secondsBox) secondsBox.style.display = "none";

                if (daysEl) daysEl.textContent = String(days).padStart(2, "0");
                if (hoursEl) hoursEl.textContent = String(hours).padStart(2, "0");
                if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
            } else {
                wrapper.classList.remove("format-days");

                const daysBox = wrapper.querySelector(".days-box");
                if (daysBox) daysBox.style.display = "none";

                const totalHours = Math.floor(totalSeconds / 3600);

                const hoursBox = wrapper.querySelector(".hours-box");
                const minutesBox = wrapper.querySelector(".minutes-box");
                const secondsBox = wrapper.querySelector(".seconds-box");

                if (hoursBox) hoursBox.style.display = "flex";
                if (minutesBox) minutesBox.style.display = "flex";
                if (secondsBox) secondsBox.style.display = "flex";

                if (hoursEl) hoursEl.textContent = String(totalHours).padStart(2, "0");
                if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
                if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, "0");
            }
        }

        update();
        setInterval(update, 1000);
    }

    initCountdown();


    /* ==============================
    TOPBAR ALTERNANTE
    ============================== */
    const topbar = document.querySelector(".topbar-alternating");

    if (topbar) {
        let showCountdown = false;
        let intervalTime = window.TOPBAR_ALTERNATE_SPEED
            ? window.TOPBAR_ALTERNATE_SPEED * 1000
            : 5000;

        setInterval(() => {
            showCountdown = !showCountdown;
            if (showCountdown) {
                topbar.classList.add("show-countdown");
            } else {
                topbar.classList.remove("show-countdown");
            }
        }, intervalTime);
    }


    /* ==============================
    MOVIMIENTO RESPONSIVE DEL BUSCADOR
    ============================== */
    const buscador = document.querySelector('.contenedor-buscador');
    const contenedorCelular = document.querySelector('.contenedor-header-buscador-celular');

    if (buscador && contenedorCelular) {

        const padreOriginal = buscador.parentElement;

        function moverBuscador() {

            const enCelular = window.innerWidth <= 700;

            if (enCelular) {
                if (buscador.parentElement !== contenedorCelular) {
                    contenedorCelular.appendChild(buscador);
                }
            } else {
                if (buscador.parentElement !== padreOriginal) {
                    padreOriginal.insertBefore(
                        buscador,
                        padreOriginal.firstChild
                    );
                }
            }
        }

        moverBuscador();

        let resizeTimeout;

        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                moverBuscador();
            }, 100);
        });
    }


    /* =====================================================
       ABRIR / CERRAR EL BUSCADOR
       ===================================================== */
    const formularioBuscador = document.getElementById("formBuscador");
    const inputBuscador = document.getElementById("buscador");

    if (formularioBuscador) {

        formularioBuscador.addEventListener("click", function(event) {

            if (
                formularioBuscador.classList.contains("buscador-abierto") &&
                event.target === inputBuscador
            ) {
                return;
            }

            if (!formularioBuscador.classList.contains("buscador-abierto")) {

                event.preventDefault();
                formularioBuscador.classList.add("buscador-abierto");

                if (inputBuscador) {
                    setTimeout(() => {
                        inputBuscador.focus();
                    }, 250);
                }
            }
        });

        document.addEventListener("click", function(event) {
            if (!formularioBuscador.contains(event.target)) {
                formularioBuscador.classList.remove("buscador-abierto");
            }
        });

        document.addEventListener("keydown", function(event) {
            if (event.key === "Escape") {
                formularioBuscador.classList.remove("buscador-abierto");
            }
        });
    }
});


/* ==============================
MENÚ CELULAR Y SUBMENÚS (OPTIMIZADO)
============================== */
let menuAbierto = false;

function toggleMenuIcon() {
    const svg = document.getElementById("id-menu-barras");
    const menu = document.getElementById("id-contenedor-menu-celular");

    if (!menu) return;

    if (!menuAbierto) {
        if (svg) {
            svg.innerHTML = `
                <path d="M232.68,134.94c16.3-.89,35.14,7.65,47.44,17.94l270.75,270.29,275.26-272.52c62.95-49.94,139.59,27.01,89.72,89.72l-272.52,273.46,277.45,282.68c35.5,62.92-36.45,126.11-94.65,82.3l-273.46-272.52-282.68,277.45c-62.97,35.35-126.15-36.27-82.3-94.65l272.52-273.46L191.12,244.35c-37.99-39.53-13.92-106.39,41.56-109.41Z"/>
            `;
        }
        menu.style.display = "block";
        menuAbierto = true;
    } else {
        if (svg) {
            svg.innerHTML = `
                <path d="M1037,513.07v19.84c-9.2,27.58-25.72,39.6-54.49,41.75H75.48c-72.39-2.39-72.31-101-.01-103.36l909.02.02c27.53,2.16,43.95,15.76,52.52,41.74Z"></path>
                <path d="M1037,207.47v19.84c-6.69,22.14-22.92,39.05-46.66,41.65-226.58-1.62-453.98,3.37-680.07-2.52-52.2-19.06-44.34-92.9,11.28-98.74l670.78.09c23.42,2.35,36.84,19.05,44.67,39.66Z"></path>
                <path d="M1037,818.67v19.84c-7.83,20.62-21.25,37.32-44.67,39.66l-476.86-1.33c-54.88-18.03-47.16-93.78,10.48-99.92l464.4.09c24.22,2.41,39.58,19.44,46.65,41.65Z"></path>
            `;
        }
        menu.style.display = "none";
        menuAbierto = false;
    }
}

function toggleSubmenuMovil(idSubmenu, elementoFlecha) {
    const submenu = document.getElementById(idSubmenu);
    if (submenu) {
        submenu.classList.toggle('activo');
        if (submenu.style.display === "block" || submenu.style.display === "flex") {
            submenu.style.display = "none";
        } else {
            submenu.style.display = "block";
        }
    }
    if (elementoFlecha) {
        elementoFlecha.classList.toggle('flechaactivasubmenu');
    }
}

function submenusalas() { toggleSubmenuMovil("id-contenedor-submenu-salas", document.getElementById("id-flecha-submenu-salas")); }
function submenurecamaras() { toggleSubmenuMovil("id-contenedor-submenu-recamaras", document.getElementById("id-flecha-submenu-recamaras")); }
function submenuantecomedores() { toggleSubmenuMovil("id-contenedor-submenu-antecomedores", document.getElementById("id-flecha-submenu-antecomedores")); }
function submenuotrosmuebles() { toggleSubmenuMovil("id-contenedor-submenu-otros-muebles", document.getElementById("id-flecha-submenu-otros-muebles")); }
function submenusucursales() { toggleSubmenuMovil("id-contenedor-submenu-sucursales", document.getElementById("id-flecha-submenu-sucursales")); }
function submenucontacto() { toggleSubmenuMovil("id-contenedor-submenu-contacto", document.getElementById("id-flecha-submenu-contacto")); }